let parser = document.createElement("a");
parser.href = location.hostname;
// parser.href = "http://cpanel-patrick.live-mobile-marketing.com/login";
//parser.href = "http://cpanel-sportapp.live-mobile-marketing.com/fanbox";
let environment = parser.hostname.split('.')[0].split("-").slice(2).slice(-1)[0]
environment =  parser.hostname.includes('github') ? '-stage' : ['stage', 'dev'].indexOf(environment) === -1 ? `` : `-${environment}`

export { environment }


// WEBPACK FOOTER //
// ./src/utilites/helpers/index.ts